import React from 'react';

import { TradingLeaderboardTier } from '@flipster/apis/v2/trading-leaderboards/types';

import { TierAllIcon, TierSharkIcon, TierStarterIcon, TierWhaleIcon } from './images';

const tierIcons: Record<TradingLeaderboardTier, React.FC<React.SVGProps<SVGSVGElement>>> = {
  ALL: TierAllIcon,
  WHALE: TierWhaleIcon,
  SHARK: TierSharkIcon,
  STARTER: TierStarterIcon,
};

interface LeaderboardTierIconProps extends Exclude<React.SVGProps<SVGSVGElement>, 'width' | 'height'> {
  tier: TradingLeaderboardTier;
  size: number;
}
export const LeaderboardTierIcon = ({ tier, size, ...props }: LeaderboardTierIconProps) => {
  const IconComponent = tierIcons[tier];
  return <IconComponent {...props} width={size} height={size} />;
};
